// extracted by mini-css-extract-plugin
module.exports = {"mainDiv":"sidebar-module--mainDiv--2hm7y","link":"sidebar-module--link--1O-1B","list":"sidebar-module--list--3T6T1"};